import {Action} from "redux";
import {
    CreateMessageRoomByCustomerRequest,
    SendMessageByCustomerRequest
} from "../request/message_room_request";
import {
    CreateMessageRoomByCustomerResponse,
    ObserveMessageRoomByCustomerResponse,
} from "../response/message_room_response";

export enum CustomerMessageRoomActionType {

    REQUEST_CREATE_MESSAGE_ROOM = "CUSTOMER_MESSAGE_ROOM_REQUEST_CREATE_MESSAGE_ROOM",
    CALLBACK_CREATE_MESSAGE_ROOM = "CUSTOMER_MESSAGE_ROOM_CALLBACK_CREATE_MESSAGE_ROOM",
    REQUEST_SEND_MESSAGE_ROOM = "CUSTOMER_MESSAGE_ROOM_REQUEST_SEND_MESSAGE_ROOM",
    CALLBACK_SEND_MESSAGE_ROOM = "CUSTOMER_MESSAGE_ROOM_CALLBACK_SEND_MESSAGE_ROOM",
    REQUEST_DESTROY_MESSAGE_ROOM = "CUSTOMER_MESSAGE_ROOM_REQUEST_DESTROY_MESSAGE_ROOM",
    CALLBACK_DESTROY_MESSAGE_ROOM = "CUSTOMER_MESSAGE_ROOM_CALLBACK_DESTROY_MESSAGE_ROOM",
    CALLBACK_OBSERVE_MESSAGE_ROOM = "CUSTOMER_MESSAGE_ROOM_CALLBACK_OBSERVE_MESSAGE_ROOM",

}

export interface IRequestCreateMessageRoomAction extends Action {
    type: CustomerMessageRoomActionType.REQUEST_CREATE_MESSAGE_ROOM;
    item: CreateMessageRoomByCustomerRequest;
}

export interface ICallbackCreateMessageRoomAction extends Action {
    type: CustomerMessageRoomActionType.CALLBACK_CREATE_MESSAGE_ROOM;
    isSuccess: boolean;
    item?: CreateMessageRoomByCustomerResponse;
    error?: any;
}

export interface IRequestSendMessageRoomAction extends Action {
    type: CustomerMessageRoomActionType.REQUEST_SEND_MESSAGE_ROOM;
    item: SendMessageByCustomerRequest,
}

export interface ICallbackSendMessageRoomAction extends Action {
    type: CustomerMessageRoomActionType.CALLBACK_SEND_MESSAGE_ROOM;
    isSuccess: boolean;
    error?: any;
}

export interface IRequestDestroyMessageRoomAction extends Action {
    type: CustomerMessageRoomActionType.REQUEST_DESTROY_MESSAGE_ROOM;
}

export interface ICallbackDestroyMessageRoomAction extends Action {
    type: CustomerMessageRoomActionType.CALLBACK_DESTROY_MESSAGE_ROOM;
    isSuccess: boolean;
    error?: any;
}

export interface ICallbackObserveMessageRoomAction extends Action {
    type: CustomerMessageRoomActionType.CALLBACK_OBSERVE_MESSAGE_ROOM;
    isSuccess: boolean;
    item?: ObserveMessageRoomByCustomerResponse;
    error?: any;
}

export type CustomerMessageRoomAction =
    IRequestCreateMessageRoomAction |
    ICallbackCreateMessageRoomAction |
    IRequestSendMessageRoomAction |
    ICallbackSendMessageRoomAction |
    IRequestDestroyMessageRoomAction |
    ICallbackDestroyMessageRoomAction |
    ICallbackObserveMessageRoomAction
    ;

export interface ICustomerMessageRoomActionCreator {

    requestCreateMessageRoomAction(
        item: CreateMessageRoomByCustomerRequest
    ): IRequestCreateMessageRoomAction;

    callbackCreateMessageRoomAction(
        isSuccess: boolean,
        item?: CreateMessageRoomByCustomerResponse,
        error?: any,
    ): ICallbackCreateMessageRoomAction;

    requestSendMessageRoomAction(
        item: SendMessageByCustomerRequest,
    ): IRequestSendMessageRoomAction;

    callbackSendMessageRoomAction(
        isSuccess: boolean,
        error?: any,
    ): ICallbackSendMessageRoomAction;

    requestDestroyMessageRoomAction(): IRequestDestroyMessageRoomAction;

    callbackDestroyMessageRoomAction(
        isSuccess: boolean,
        error?: any,
    ): ICallbackDestroyMessageRoomAction;

    callbackObserveMessageRoomAction(
        isSuccess: boolean,
        item?: ObserveMessageRoomByCustomerResponse,
        error?: any,
    ): ICallbackObserveMessageRoomAction;

}

class ActionCreator implements ICustomerMessageRoomActionCreator {

    public requestCreateMessageRoomAction = (
        item: CreateMessageRoomByCustomerRequest
    ): IRequestCreateMessageRoomAction => {
        return {
            type: CustomerMessageRoomActionType.REQUEST_CREATE_MESSAGE_ROOM,
            item,
        };
    };

    public callbackCreateMessageRoomAction = (
        isSuccess: boolean,
        item?: CreateMessageRoomByCustomerResponse,
        error?: any,
    ): ICallbackCreateMessageRoomAction => {
        return {
            type: CustomerMessageRoomActionType.CALLBACK_CREATE_MESSAGE_ROOM,
            isSuccess,
            item,
            error,
        };
    };

    public requestSendMessageRoomAction = (
        item: SendMessageByCustomerRequest,
    ): IRequestSendMessageRoomAction => {
        return {
            type: CustomerMessageRoomActionType.REQUEST_SEND_MESSAGE_ROOM,
            item,
        };
    };

    public callbackSendMessageRoomAction = (
        isSuccess: boolean,
        error?: any,
    ): ICallbackSendMessageRoomAction => {
        return {
            type: CustomerMessageRoomActionType.CALLBACK_SEND_MESSAGE_ROOM,
            isSuccess,
            error,
        };
    };

    public requestDestroyMessageRoomAction = (): IRequestDestroyMessageRoomAction => {
        return {
            type: CustomerMessageRoomActionType.REQUEST_DESTROY_MESSAGE_ROOM,
        };
    };

    public callbackDestroyMessageRoomAction = (
        isSuccess: boolean,
        error?: any,
    ): ICallbackDestroyMessageRoomAction => {
        return {
            type: CustomerMessageRoomActionType.CALLBACK_DESTROY_MESSAGE_ROOM,
            isSuccess,
            error,
        };
    };

    public callbackObserveMessageRoomAction = (
        isSuccess: boolean,
        item?: ObserveMessageRoomByCustomerResponse,
        error?: any,
    ): ICallbackObserveMessageRoomAction => {
        return {
            type: CustomerMessageRoomActionType.CALLBACK_OBSERVE_MESSAGE_ROOM,
            isSuccess,
            item,
            error,
        };
    };

}

export const createCustomerMessageRoomActionCreator = (): ICustomerMessageRoomActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/customer_message_room_action.ts